import React, { useContext, useEffect } from 'react'
import { useParams } from 'react-router'
import { useFeatures } from '../../hooks/Features/useFeatures'
import { CategoryContext } from '../../context api/Category/CategoryContext'
import { SubCategoryContext } from '../../context api/SubCategory/SubCategoryContext'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UseBeatPlan } from '../../hooks/beatPlan/useBeatPlan'
import { useChannelType } from '../../hooks/CompanyConfiguration/useChannelType'
import {useSalesChannelType} from '../../hooks/CompanyConfiguration/useSalesChannelType'
import { useQuery, useQueryClient } from 'react-query'
import { deleteDocumentById, getAllData, updateDocumentByID, axiosAuth } from '../../lib/RestApi/customApiHandler'
import { EmployeeContext } from '../../context api/Employee/EmployeeContext'
import { useCompanyAdmin } from '../../hooks/CompanyAdmin/useCompanyAdmin'
import { useStates } from'../../hooks/CompanyConfiguration/useStates'
import { useCity } from'../../hooks/CompanyConfiguration/useCity'
import CustomSelect from '../../components/CustomSelect'
import { Typography } from '@material-ui/core'

import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'
import { UserContext } from '../../context api/UserContext'

export default function BeatPlanForm({ state, setState }) {
    
  const { channelName, channelType, 
    city, 
    status, 
    state: empState,
    employee, action, date} = state
  const {getAllChannelType}  = useChannelType();
  const { salesChannelTypes } = useContext(ConfigurationContext)
  const { user } = useContext(UserContext)
  const { getAllSalesChannelType } = useSalesChannelType()
  const {getAllStates} = useStates()
  const {getAllCity} = useCity()
  const {getSingleBeatPlan} = UseBeatPlan();
  const { channelTypes, states, city: cities } = useContext(ConfigurationContext)
  // let { data: employees } = useQuery(['all-emp'], () => getAllData('/CAallEmployee/getAllEmployee'))

  const { getAllEmployee, getEmployeeByRank, updateEmployee, getEmployee, employee: emp, rankedEmployees} = useCompanyAdmin()
  const { employees, addNewEmployee } = useContext(EmployeeContext)
  const today = new Date();
  const params = useParams();
  useEffect(() => {
      getAllChannelType()
      // getAllEmployee()
      getEmployeeByRank({rank: 6  });
      getAllStates();
      console.log("channelTypes====================>", channelTypes);
  }, [])

  

  // useEffect(()=>{
  //   if(params.id !== undefined){
  //     let obj = getSingleBeatPlan(params.id)
  //     setState({...obj});
  //     console.log(obj);
  //   }
  // }, [params])

  useEffect(() => {
    if(channelType){
      getAllSalesChannelType({ page: 1, channelType: channelType})
    }
  }, [channelType])
  useEffect(() => {
    if(employee){
      getEmployee({ userId: employee})
    }
  }, [employee])

  useEffect(()=>{
    setState({...state, 
      city: emp?.city?._id, 
      state: emp?.state?._id 
    });
  }, [emp])

  useEffect(()=>{
    if(empState)
    getAllCity({ state: empState});

  }, [empState])


  const input = [
    {
      label: 'Select Channel Type',
      value: channelType,
      name: 'channelType',
      fieldName: 'name',
      fieldValue: '_id',
      options: channelTypes,
    },
    {
      label: 'Channel Name',
      value: channelName,
      name: 'channelName',
      fieldName: 'name',
      fieldValue: '_id',
      options: salesChannelTypes,
    },
    { 
      label: 'Date',
      value: date, 
      name: 'date', 
      type: 'DATE',
      minDate: new Date()
    },
    {
      label: 'Employee',
      value: employee,
      name: 'employee',
      fieldName: 'firstName',
      fieldValue: '_id',
      options: rankedEmployees,
      disabled : user.position==='KBC',
      view : user.position!=='KBC',
    },
    {
      label : 'State', 
      value : empState ? empState : emp?.state?._id,
      // disabled : true,
      name: 'state',
      fieldName: 'name',
      fieldValue: '_id',
      options: states,
      noValidate : true
    },  
    {
      label : 'City', 
      value : city!== ''? city : emp?.city?._id ,
      // disabled : true,
      name: 'city',
      fieldName: 'name',
      fieldValue: '_id',
      options: cities,
      noValidate: true
    },
  ]

  return <>
  <CustomAddForm state={state} setState={setState} data={input} />
  </>
}
